<template>
  <div class="content">
    <img alt="" class="logo" src="../../assets/photo/logo5.png">
    <div class="box">
      <div class="left">
        <img alt="" src="../../assets/photo/my.png">
      </div>
      <div class="list">
        <div v-for="e in listData" class="card">
          <p>{{ e.messageContent }}</p>
          <el-image v-for="s in e.messageUrl && e.messageUrl.split(',') || []"
                    :preview-src-list="e.messageUrl.split(',')"
                    :src="s"
                    style="width: 100px; height: 100px; margin-right: 10px;border-radius: 10px;margin-top: 10px;">
          </el-image>
        </div>
        <div class="fy">
          <el-pagination
            :page-size="10"
            :total="total"

            layout="prev, pager, next"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {messagePage} from '@/api/roast'

export default {
  name: "company",
  data() {
    return {
      url: 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      dialogVisible: false,
      dialogImageUrl: '',
      dialogVisibleImg: false,
      fileList: [],
      current: 1,
      textarea1: '',
      listData: [],
      total: 0,
    }
  },
  components: {},
  mounted() {
    this.handleSearch()
    document.title = "一个树洞";
  },
  methods: {
    handleSearch() {
      messagePage({
        current: this.current,
        size: 10
      }).then((res) => {
        this.total = res.data.data.total
        this.listData = res.data.data.records
      });
    },
    changePage(val) {
      this.current = val
      this.handleSearch()
    },
    handleChange(file, fileList) {
      console.log(fileList)
    },
    add() {
      console.log(this.fileList)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImg = true;
    },
    init() {
      if (this.model.employeeId) {
        employeeDetail({employeeId: this.model.employeeId}).then((res) => {
          this.formCustom = res.data.data
        });
      } else {
        this.formCustom = {}
      }
      employeeFamilyMemberPage({employeeId: this.model.employeeId, current: 1, size: 99}).then((res) => {
        this.tableData = res.data.data.records;
        this.loading = false;
      });
    },
    roastAdd() {
      this.dialogVisible = true
    }
  }
}
</script>
<style>
.box {
  width: 1200px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  margin-top: 200px;
  height: 600px;
  border-radius: 10px;
}

.left {
  border-radius: 10px 0px 0px 10px;
  background-color: #93a4c6;
  height: 600px;
  width: 80px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  background-color: #f1f1f1;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: auto;
  padding-top: 10px;
  background-image: url(../../assets/photo/bg.png);
  background-size: cover;
  background-position: center;
}

.logo {
  position: absolute;
  top: 80px;
  left: calc(50vw - 600px);
  z-index: 2;
}

.list {
  height: 580px;
  overflow: auto;
  padding: auto;
  margin-top: 20px;
  margin-left: 60px;
}

.list::-webkit-scrollbar-thumb {
  display: block;
  width: 2px;
  margin: 0 auto;
  border-radius: 10px;
  background: #93a4c6; /*内层轨道*/
}

.list::-webkit-scrollbar {
  width: 10px;
  height: 2px;
  background: #ffffff;
  border-radius: 10px; /*外层轨道*/
}

.card {
  width: 1000px;
  background-color: #ebf1fc;
  border-radius: 5px;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 10px;
  color: #93a4c6;
}

.fy {
  background-color: #fff;
  width: 640px;
  margin-bottom: 10px;
}
</style>
